export enum InfraTypeEnum {
  EC2 = 1,
  VPS = 2,
  DATABASE = 3,
  DOMAIN = 4,
  STORAGE = 5,
  CDN = 6,
  OTHER = 99,
}

export enum InfraHostCompanyEnum {
  AWS = 1,
  GODADDY = 2,
  HOSTINGER = 3,
  DIGITAL_OCEAN = 4,
  CLOUDFLARE = 5,
  OTHER = 99,
}

export enum InfrastructureStatusEnum {
  ACTIVE = "a",
  INACTIVE = "i",
  MAINTENANCE = "m",
  PROVISIONING = "p",
  STOPPED = "s",
  DECOMMISSIONED = "d",
}

export type InfrastructureStatusTypes = `${InfrastructureStatusEnum}`;

export interface InfrastructureListQuery {
  page?: number;
  take?: number;
  search?: string;
  name?: string;
  typeId?: InfraTypeEnum;
  typeIds?: InfraTypeEnum[];
  hostId?: InfraHostCompanyEnum;
  hostIds?: InfraHostCompanyEnum[];
  status?: InfrastructureStatusTypes;
  statuses?: InfrastructureStatusTypes[];
  region?: string;
  instanceType?: string;
  minVCpu?: number;
  maxVCpu?: number;
  minRamGb?: number;
  maxRamGb?: number;
  minRamSwapGb?: number;
  maxRamSwapGb?: number;
  minDiskGb?: number;
  maxDiskGb?: number;
}

export interface InfrastructureReferenceData {
  id: number;
  name: string;
  website?: string;
  createdAt: string;
  updatedAt: string;
}

export interface InfrastructureListItem {
  id: number;
  name: string;
  description?: string;
  typeId: InfraTypeEnum;
  typeData: InfrastructureReferenceData;
  hostId?: InfraHostCompanyEnum;
  hostData?: InfrastructureReferenceData;
  status: InfrastructureStatusTypes;
  ip: string;
  providerResourceId?: string;
  instanceType?: string;
  hostname?: string;
  region?: string;
  cpuModel?: string;
  vCpu?: number;
  ramGb?: number;
  ramSwapGb?: number;
  diskGb?: number;
  operatingSystem?: string;
  operatingSystemVersion?: string;
  notes?: string;
  createdAt: string;
  updatedAt: string;
}

export interface InfrastructureListResponse {
  infrastructures: InfrastructureListItem[];
  totalPages: number;
  total: number;
  page: number;
  take: number;
}
